/*
THIS COMPONENT IS INCLUDED IN FORM-EDIT PRODUCT PAGE
 -----------------------------------------*/

/*  RELATED PRODUCT
 ----------------------------------*/

let RelatedProduct = {
    init: () => {
        $('body').on('click', '#similar_products_table td', function(el) {

            let selectedContainer = $('.b-similar-products__selected-list');
            let chk = $(this).closest("tr").find("input:checkbox").get(0);
            let checkboxVal = $(chk).val();
            let checkedName = $(chk).data('name');

            if(el.target != chk) {
                chk.checked = !chk.checked;
            }

            if(chk.checked == false) {
                let similarProductContainer = $(selectedContainer).find('.similar_' + checkboxVal);
                similarProductContainer.hide();
                similarProductContainer.find('input').attr("checked", false);

                $(this).parent().removeClass('selected');
            } else {
                $(this).parent().addClass('selected');
                $(selectedContainer)
                    .append('<li class="similar_'+ checkboxVal +'">' +
                        '<label for="similar_'+ checkboxVal +'">' +
                        '<input type="checkbox" id="similar_'+ checkboxVal +'" name="similar[]" checked value="'
                        + checkboxVal +'" /> '+ checkedName +' </li>' +
                        '</label>');

            }
        });

    }
};


export default RelatedProduct;
